import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { UrlService } from '@src/app/services/url.service';
import { ILenders, IPartner } from '@src/app/models/models';

@Injectable()
export class PartnerService {
  private http = inject(HttpClient);
  private url = inject(UrlService);

  public getOffers(): Observable<IPartner[]> {
    return this.http.get<IPartner[]>(`${this.url.host}/offers`);
  }

  public getLeaders(): Observable<ILenders[]> {
    return this.http.get<ILenders[]>(`${this.url.host}/lenders`);
  }

  public acceptedOffer(id: number): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(`${this.url.host}/accepted-offers`, {id});
  }
}
